import { Button } from "~/common/mui";
import { useTranslation } from "react-i18next";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

interface Props {
  resultAmount: number;
  className?: string;
}
export const ShowProductsBtn = ({ resultAmount, className }: Props) => {
  const { t } = useTranslation();
  return (
    <Button size={"medium"} href={"#results"} className={className}>
      <ArrowDownwardIcon className="icon-margin" data-test-id={"selectionassistant-showallproducts"}  />
      <span>
        {t("page.selectionAssistant.showNumberOfProducts", {
          count: resultAmount,
        })}
      </span>
    </Button>
  );
};
